setLiveAccessSchedule